import { Empty, Popover } from 'antd'
import Button from 'components/Button/index'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import AddBlueIcon from 'components/icons/AddBlueIcon'
import ErrorIcon from 'components/icons/ErrorIcon'
import EyeIcon from 'components/icons/EyeIcon'
import LinkIcon from 'components/icons/LinkIcon'
import UploadIcon from 'components/icons/UploadIcon'
import Uploader from 'components/Uploader/ImageUploader'
import AddMediaLinksDrawer from 'modules/Settings/Components/AddtionalInfo/AddMediaLinksDrawer/index'
import {
  AddLinkspan,
  AddMediaButton,
  ComanyDiv,
  CommonFlex,
  Container,
  CopyLinkDiv,
  Divider,
  DocumentFlex,
  FileInfoLi,
  ImageSpan,
  MainWrapper,
  NoDataDiv,
  PopoverImg,
  PreviewDiv,
  RightSection,
  SubTitleDiv,
  Ul,
} from 'modules/Settings/Components/AddtionalInfo/style'
import React, { useState } from 'react'
import { copyText } from 'utils/copyText'
import { getYear } from 'utils/getYear'

const AddtionalInfo = ({
  instituteData,
  socialMediaList,
  setSocialMediaList,
  presentationFile,
  setPresentationFile,
  onChangeFormFields,
  settingsForm,
}) => {
  const [addMediaDrawer, setAddMediaDrawer] = useState(false)

  const onLinkChange = (linkValue, updateIndex) => {
    const updatedData = socialMediaList?.map((item, index) => {
      if (index == updateIndex) {
        return {
          ...item,
          link: linkValue,
        }
      } else {
        return item
      }
    })
    setSocialMediaList(updatedData)
    onChangeFormFields()
  }
  const mediaOptions = [
    {
      name: 'Facebook',
      value: 'Facebook',
    },
    {
      name: 'Instagram',
      value: 'Instagram',
    },
    {
      name: 'Linkedin',
      value: 'Linkedin',
    },
    {
      name: 'Twitter',
      value: 'Twitter',
    },
  ]

  return (
    <>
      <Container>
        <MainWrapper>
          <Flex centerVertically>
            <ComanyDiv>
              Institute Additional Info
              {!presentationFile && (
                <ImageSpan>
                  <ErrorIcon />
                </ImageSpan>
              )}
            </ComanyDiv>
          </Flex>
          <CommonFlex spaceBetween>
            <div>
              <SubTitleDiv>Institute Presentation</SubTitleDiv>
              <Flex column>
                <Ul>
                  <FileInfoLi>Max size: 10 MB</FileInfoLi>
                  <FileInfoLi>
                    Supported format : pdf, png, jpg, jpeg
                  </FileInfoLi>
                  <FileInfoLi>
                    Supported name format : filetype_name_year
                  </FileInfoLi>
                </Ul>
              </Flex>
            </div>
            <RightSection>
              {!presentationFile && (
                <Uploader
                  setFile={setPresentationFile}
                  isDefault={!presentationFile}
                  fileName={
                    instituteData?.campusName
                      ?.toLowerCase()
                      .replace(/\s/g, '') +
                    '_presentation' +
                    '_' +
                    getYear(presentationFile?.date)
                  }
                  defaultButtonTrigger={
                    <div>
                      <Button.Secondary
                        icon={<UploadIcon />}
                        text="Upload File"
                        height="32px"
                      />
                    </div>
                  }
                />
              )}

              {presentationFile ? (
                <DocumentFlex alignCenter>
                  {!!presentationFile?.url && (
                    <Popover
                      getPopupContainer={() =>
                        document.getElementById(`presentationFile`)
                      }
                      content={<PopoverImg src={presentationFile?.url} />}
                      trigger="hover"
                    >
                      <PreviewDiv id={'presentationFile'}>
                        <EyeIcon />
                      </PreviewDiv>
                    </Popover>
                  )}
                  <Uploader
                    isDelete={true}
                    file={presentationFile}
                    setFile={setPresentationFile}
                    isDefault={presentationFile}
                    fileName={
                      instituteData?.campusName
                        ?.toLowerCase()
                        .replace(/\s/g, '') +
                      '_presentation' +
                      '_' +
                      getYear(presentationFile?.date)
                    }
                    defaultButtonTrigger={
                      <Button.Primary text="Change File" height="32px" />
                    }
                  />
                  <Button.Secondary
                    text="Remove"
                    onClick={() => setPresentationFile(null)}
                    height={'32px'}
                    width="76px"
                  />
                </DocumentFlex>
              ) : null}
            </RightSection>
          </CommonFlex>

          <CommonFlex spaceBetween>
            <SubTitleDiv>Institute Video Link</SubTitleDiv>
            <RightSection>
              <Input
                placeholder="Eg. www.youtube.com/results?search_query=about+iim"
                width="100%"
                suffix={
                  <CopyLinkDiv
                    onClick={() =>
                      copyText(settingsForm.getFieldValue('instituteVideoLink'))
                    }
                  >
                    <LinkIcon />
                  </CopyLinkDiv>
                }
                name="instituteVideoLink"
                // type='url'
              />
            </RightSection>
          </CommonFlex>
        </MainWrapper>

        <Divider />
        <MainWrapper marginBottom="100px">
          <Flex spaceBetween>
            <ComanyDiv>Social Media</ComanyDiv>
            {mediaOptions?.filter(
              item =>
                !socialMediaList
                  ?.map(data => data?.media)
                  ?.includes(item?.value)
            )?.length ? (
              <AddMediaButton
                onClick={() => setAddMediaDrawer(true)}
                text={<AddLinkspan>Add More Link</AddLinkspan>}
                icon={<AddBlueIcon />}
              />
            ) : null}
          </Flex>

          {socialMediaList?.length ? (
            socialMediaList?.map((item, index) => (
              <CommonFlex spaceBetween key={index + 'static'}>
                <SubTitleDiv>{item?.media}</SubTitleDiv>
                <RightSection>
                  <Input
                    defaultValue={item?.link}
                    name={item?.media + index}
                    // type="url"
                    placeholder="https://www.website.com"
                    width="100%"
                    suffix={
                      <CopyLinkDiv onClick={() => copyText(item?.link)}>
                        <LinkIcon />
                      </CopyLinkDiv>
                    }
                    onChange={({ target }) =>
                      onLinkChange(target?.value, index)
                    }
                  />
                </RightSection>
              </CommonFlex>
            ))
          ) : (
            <NoDataDiv>
              <Empty description="No media links" />
            </NoDataDiv>
          )}
        </MainWrapper>
      </Container>
      {addMediaDrawer && (
        <AddMediaLinksDrawer
          addMediaDrawer={addMediaDrawer}
          setAddMediaDrawer={setAddMediaDrawer}
          socialMediaList={socialMediaList}
          setSocialMediaList={setSocialMediaList}
          onChangeFormFields={onChangeFormFields}
          mediaOptions={mediaOptions}
        />
      )}
    </>
  )
}

export default AddtionalInfo
